<template>
  <div class="qr-scan-page">
    <div class="qr-content">
      <div class="qr-header">
        <img src="../assets/pivo.png" alt="" />
      </div>
      <div class="qr-body">
        <div class="info">
          <h1 style="margin: 0 0 50px 0">To use Pivo Meet on your computer:</h1>
          <div class="info-text">
            <span>1. Open Pivo Meet on your phone and go the Cast mode</span>
            <span
              >2. Point your phone camera to this screen to capture the
              code</span
            >
          </div>
        </div>
        <div class="qr-code-box">
          <div v-if="!qrcode" style="height: 250px; width: 250px">
            Loading...
          </div>
          <div v-else>
            <qrcode :value="qrcode" :options="{ width: 250 }"></qrcode>
          </div>
        </div>
      </div>
      <div class="qr-footer">
        <a href="https://help.getpivo.com" style="color: #ec2544"
          >Need help to get started</a
        >
      </div>
    </div>
  </div>
</template>

<script>
  import VueQrcode from "@chenfengyuan/vue-qrcode";
  import Store from "@/utils/store";
  import io from "socket.io-client";

  export default {
    components: {
      [VueQrcode.name]: VueQrcode,
    },

    data() {
      return {
        qrcode: null,
        remoteStreamAvailable: false,
      };
    },

    created() {
      this.getRoomId();
    },

    methods: {
      stream() {
        this.$router.push({ name: "live" });
      },

      async getRoomId() {
        const LOCALHOST = "pivo.dev";
        let HOST = "";
        if (process.env.NODE_ENV === "development") {
          HOST = `https://api.${LOCALHOST}/`; // pivo.dev
        } else {
          const tmp = window.location.hostname.split(".");
          const [subdomain] = tmp;
          if (subdomain) {
            tmp.shift(); // remove sub domain, ex:  cast.pivo.app  ->  pivo.app
          }
          const BASE_HOST = tmp.join(".");
          HOST = `https://api.${BASE_HOST}/`;
        }
        console.log(HOST);
        const URL = `${HOST}qr/url`;
        // const URL = "https://7e7c3337dbfe.ngrok.io/qr/url"
        try {
          const resp = await fetch(URL);
          const room = await resp.json();

          console.log("room ", room);
          const { data } = room;
          Store.set("live-room", JSON.stringify(data));
          console.log("dataaa domain", data.domain);
          const wsURL = `${data.domain}/${data.namespace}?roomId=${data.roomId}`;
          // const socket = io.connect(wsURL, {
          //   transports: ['websocket']
          // });
          const socket = io.connect(wsURL, {
            transports: ["websocket"],
          });

          this.qrcode = JSON.stringify(data);

          // both
          socket.on("connect", () => {
            console.log("socket connection whoaa");
          });

          socket.on("get-session-data", async (session) => {
            await socket.disconnect();
            Store.set("live-session", JSON.stringify(session.data));
            this.$router.push({ name: "live" });
          });
          // const wsURL = `${SOCKET_URL}/${SESS_PATH}?roomId=${roomId}&accessToken=${auth.accessToken}`;
          // window.socket = io(wsURL);
        } catch (err) {
          console.error(err);
        }
      },
    },
  };
</script>

<style scoped>
  .qr-scan-page {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .qr-content {
    width: 60%;
    height: 60%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .qr-header {
    width: 100%;
    height: 100px;
  }

  .qr-header img {
    width: 150px;
    height: auto;
  }

  .qr-body {
    display: flex;
    align-items: center;
  }

  .qr-body .info {
    flex: 1;
  }

  .info-text {
    width: 100%;
  }
  .info-text span {
    display: block;
    font-size: 1.2em;
  }

  .qr-code-box {
    min-height: 250px;
  }

  button {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    transition: 0.1s;
    font-weight: 500;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
  }
</style>
